// Shared HTML sanitization helpers for content rendered with v-html.

// Remove <script> blocks from HTML rendered with v-html.
export function stripScripts(html) {
    if (!html) return '';
    return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
}

// Stricter variant for user-authored content (course notes): also removes
// inline on* handlers and javascript: URLs. The API applies the same rules on
// write; this guards the render path regardless of what's stored.
export function sanitizeHtml(html) {
    if (!html) return '';
    return stripScripts(html)
        .replace(/\son\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
        .replace(/(\s(?:href|src)\s*=\s*["']?)\s*javascript:/gi, '$1');
}
